import {post, get, put, del} from '@/api/request.js'

const url = '/admin/intelligent/wizard'
/**
 * 获取智能向导内容
 * @returns {Promise<void>}
 */
export const get_intelligent_wizard = async function () {
    return await get(url)
}

/**
 * 创建智能向导内容
 * @param {string}title 标题
 * @param {number}path 跳转路径
 * @param {type}type 匹配类型
 * @param {Array}keys 关键字
 * @returns {Promise<AxiosResponse<any>>}
 */
export const create_intelligent_wizard = async function (title, path, type, keys) {
    return await post(url, {
        data: {
            title, path, type, keys
        }
    })
}

/**
 * 修改智能向导内容
 * @param {string}title 标题
 * @param {number}path 跳转路径
 * @param {type}type 匹配类型
 * @param {Array}keys 关键字
 * @param id{number} id
 * @returns {Promise<AxiosResponse<any>>}
 */
export const edit_intelligent_wizard = async function (title, path, type, keys, id) {
    return await put(url, {
        data: {
            title, path, type, keys
        },
        params: {
            id
        }
    })
}

/**
 * 删除智能向导内容
 * @param id{number} id
 * @returns {Promise<AxiosResponse<any>>}
 */
export const delete_intelligent_wizard = async function (id) {
    return await del(url, {
        params: {
            id
        }
    })
}


/**
 * 获取智能向导关键字
 * @returns {Promise<void>}
 */
export const get_intelligent_wizard_key = async function () {
    return await get('/admin/key')
}
